// src/components/dialog/DlgFolderPoolInfo.tsx

import {
  Dialog,
  DialogContent,
  DialogTitle,
  Stack,
  Typography,
} from '@mui/material'

import { FolderPool } from '@/types/domain/folder'
import { KARMA_BasicDialog } from '@/types/karma/dialog'

import { DlgCloseButton, HStack } from '..'
import { FILTER_MAIN_FOLDER, FILTER_SUB_FOLDER } from '../../api/'
import { useFolderPool } from '../../hooks'

type StatRecordProps = {
  label: any
  value: any
}

const StatRecord = ({ label, value, ...rest }: StatRecordProps) => (
  <HStack spacing={2} sx={{ width: 1 }} {...rest}>
    <Stack sx={{ flex: 1, textAlign: 'right' }}>
      <Typography>{label}</Typography>
    </Stack>

    <Stack sx={{ flex: 1, textAlign: 'left' }}>
      <Typography>{value}</Typography>
    </Stack>
  </HStack>
)

const FolderPoolStat = () => {
  const fPool: FolderPool = useFolderPool()

  return (
    <Stack sx={{ mt: 3 }}>
      <StatRecord label={'Poolgröße'} value={fPool.length} />

      {[
        {
          label: 'Hauptgebäude',
          value: [...new Set(fPool.filter(FILTER_MAIN_FOLDER))].length,
        },
        {
          label: 'Untergebäude',
          value: [...new Set(fPool.filter(FILTER_SUB_FOLDER))].length,
        },
      ].map(item => (
        <StatRecord key={item.label} label={item.label} value={item.value} />
      ))}
    </Stack>
  )
}

export const DlgFolderPoolInfo = ({ onClose, open }: KARMA_BasicDialog) => (
  <Dialog fullWidth open={open}>
    <DialogTitle>
      <Typography>Gebäude Pool Info</Typography>

      <DlgCloseButton onClick={onClose} />
    </DialogTitle>

    <DialogContent>
      <FolderPoolStat />
    </DialogContent>
  </Dialog>
)
